import React, {useState,useEffect} from 'react'
import downArrow from "../images/orgarrow.svg";
import { useNavigate } from "react-router-dom";
import arrow from '../images/thinArrow.png'
import checkmarkGreen from '../images/checkmark-green.png';
import checkmarkRed from '../images/checkmark-red.png'
import calendar from '../images/Icon-Calendar.png';
import moment from 'moment';
import { DayPicker  } from 'react-day-picker';
import da from "date-fns/locale/da";
import close from '../images/close.png'

import { format, isSameMonth } from "date-fns";

function NotSentNewsletter() {
  const key = sessionStorage.getItem("key");
  const [bios, setBios] = useState([{}]);
  const navigate = useNavigate();
  const [showDiv, setShowDiv] = useState(false);
  const [chosenBio, setchosenBio] = useState();
 
  const [calendarOpen, setcalendarOpen] = useState();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [month, setMonth] = useState(); 
 
 const disabledDays = [{ from: new Date(2022, 0, 1), to:  moment().subtract(1, 'day').toDate() }] ;

 let date = moment(selectedDate).format("DD.MM.YYYY") 


   useEffect(() => {
      const endpoint = `https://biograf.ebillet.dk/systemnative/report.asmx/man_getorganizers?Key=${key}`;
      if (key) {
        fetch(endpoint, {
          method: "GET",
          headers: {
            ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
          },
        })
          .then((res) => {
            if (res.status !== 200) {
              navigate("/");
            }
            return res.json();
          })
          .then((result) => {
            // console.log(result)
            setBios(result);
  
            // console.log('biograf length',result.length)
            if (result.length === 1) {
            }
            // setMovieNumber(result.map((number) => number.No));
          });
      }
    }, [key]);

    function handleClick () {
         setShowDiv((current => !current))
    }
    
    function handleBioSelect (e) {
        setchosenBio(e.target.value);
    }

    function timestampChange (e) {
      // console.log(e)
    }
      function handleCalendar() {
     setcalendarOpen(current => !current)
    }

    function handleDatoSelect () {

    }
    //  document.getElementById("appointment")?.defaultValue = "18:00";
// console.log(bios)
  return (
    <div className='NotsentNewsletter'> 
      <p className='newsletter_title'>Ikke udsendte nyhedsbreve</p>
         <label htmlFor="" style={{fontSize:'18px',fontWeight:700,letterSpacing:'0.36px',color:'#46484c',marginBottom:'11px'}}>Biograf</label>
         <div className="movieListBox" style={{width: "384px",}}> 
     
          <span className="select-line" style={{ backgroundColor: "#8d8d8d" ,position:'absolute',right:'30px',width:'0.5px'}}></span>
            
        <select  onChange={handleBioSelect} 
                  className="form-select text-truncate"
                  value={chosenBio}
                  style={{
                    height: "40px",
                   border: "1px solid #8d8d8d",
                    backgroundRepeat: "no-repeat",
                    color:'#46484c',
                   // backgroundColor: "#f7f7f7",
                     backgroundImage: `url(${downArrow})`,
                  }}
                >
                 {bios &&
                    bios.map((item) => {
                      let bb = item.City + " - " + item.Name + " " + item.No;
                      return (
                        <option
                          key={item.id}
                          value={bb}
                          className="text-truncate"
                          style={{
                            maxWidth:'380px',
                            marginLeft: "10px",
                            fontSize: "16px",width:'370px'
                          }}
                        >
                          {item.City} - {item.Name}
                        </option>
                      );
                    })}
                </select>
        </div>
        <div className='newsMailHeader'> 
          <p style={{alignContent:'center',margin:0,}}>Navn på nyhedsmail</p>
          <p style={{alignContent:'center',margin:0,textAlign:'center'}}>Segment</p>
          <p style={{alignContent:'center',margin:0,textAlign:'center'}}>Udsendelsesdato</p>
          <p style={{alignContent:'center',margin:0,textAlign:'center'}}> Tidspunkt</p>
          <p style={{alignContent:'center',margin:0,textAlign:'center'}}>Udsendelse aktiveret</p>
          <p style={{alignContent:'center',margin:0,textAlign:'center',width:'50px'}}></p>
        </div>
        <div style={{borderBottom: showDiv === true ? '1px solid' : '',border: showDiv === true ? '2px solid #ccced1' : '',borderRadius:'2px',marginTop:'13px'}}>
         <div className='newsMailBody' style={{border: showDiv === false ? '1px solid #ccced1' : ''}}> 
          <p style={{alignContent:'center',margin:0,paddingLeft:'16px'}}>Først weekend i marts</p>
          <p style={{alignContent:'center',margin:0,textAlign:'center'}}>Operakunder</p>
          <p style={{alignContent:'center',margin:0,textAlign:'center'}}>01-03-2025</p>
          <p style={{alignContent:'center',margin:0,textAlign:'center'}}>11:00</p>
          <p style={{alignContent:'center',margin:0,textAlign:'center'}}>-</p>
          <p onClick={handleClick} style={{textAlign:'center',lignContent:'center',cursor:'pointer',marginTop:'15px',rotate:showDiv === false ? '180deg' : ''}}><svg xmlns="http://www.w3.org/2000/svg" width="18" height="10" viewBox="0 0 18 10" fill="none">
          <path d="M0.353546 0.355469L8.85355 8.85547L17.3535 0.355469" stroke="#101010"/>
          </svg></p>
         
        </div>
        {
          showDiv === true ? <div >
            <div className='openedMailDiv' style={{borderTop:'1px solid #ccced1',padding:'30px 80px'}} >
             <div style={{width:'384px',marginRight:'51px'}}>
                 <p className='openedMailTitel'>Navn på nyhedsmail</p>
                 <input style={{width:'100%',padding:'6px 13px 8px',borderRadius:'4px',border:'1px solid #8d8d8d',marginTop:'10px',color:'#101010'}} type="text" />
             </div>
             <div style={{width:'178px',marginRight:'28px',position:'relative'}}>
                 <p className='openedMailTitel' style={{fontSize:'16px'}}>Vælg udsendelsesdato</p>
                <div style={{width:'100%',padding:'6px 13px 8px',border:'1px solid #8d8d8d',borderRadius:'4px',marginTop:'10px',height:'40px',color:'#46484c'}} >
                {date} 
                   <span className="select-line" style={{ backgroundColor: "#8d8d8d" ,position:'absolute',right:'30px',top:'35px',height:'38px'}}></span>
                <button onClick={handleCalendar} style={{position:'absolute',right:'5px',top:'38px'}}><img  src={calendar} alt="" /></button>   
                </div>

                 {calendarOpen ? (
    <div className='startDatoCal' style={{}}>
        <div style={{height:'35px',backgroundColor:'#f1f5f9',display:'flex',justifyContent:'space-between',margin:'4px',}}>
           <p style={{fontSize:'12px',fontWeight:'bold',padding:'8px'}}>Startdato</p>
           {/* <button><img src={iconCross} alt="" onClick={handleStartDatoCal}/></button> */}
        </div>
        <div className="weekdays"  >
                            <span className="days">Man</span>
                            <span className="days">Tirs</span>
                            <span className="days">Ons</span>
                            <span className="days">Tors</span>
                            <span className="days">Fre</span>
                            <span className="days">Lør</span>
                            <span className="days">Søn</span>
                          </div>
        <DayPicker 
         month={month} 
            onMonthChange={setMonth}  locale={da} mode="single" ISOWeek  showOutsideDays  showWeekNumber selected= {selectedDate} captionLayout="dropdown" fromYear={2022} toYear={2030} onSelect={setSelectedDate} onDayClick={handleDatoSelect}  disabled={disabledDays}/>
    </div>
  ) : ''}
                
             </div>
              <div style={{width:'178px',position:'relative'}}>
                 <p className='openedMailTitel' style={{fontSize:'16px'}}>Vælg tidspunkt</p>
                 <input onChange={(e) => timestampChange(e)}  className='time-input'   type="time" id="appointment" defaultValue='10:05' 
                 />
                 <span style={{position:'absolute',top:'42px',left:'13px'}}>Kl.</span>
                
                   <span className="select-line" style={{ backgroundColor: "#8d8d8d" ,position:'absolute',right:'28px',top:'35px',height:'39px'}}></span>
                 {/* <input style={{width:'100%',padding:'6px 13px 8px',border:'1px solid #8d8d8d',borderRadius:'4px',marginTop:'10px'}} type="text" /> */}
             </div>
             
             </div>
             <div className='openedMailDiv' style={{paddingLeft:' 80px'}}>
               <div style={{width:'384px',marginRight:'51px',position:'relative'}}>
                 <p className='openedMailTitel'>Vælg segment</p>
                   <select style={{ backgroundImage: `url(${downArrow})`,width:'100%',border:'1px solid #8d8d8d',borderRadius:'4px',marginTop:'10px',height:'40px'}}  className="form-select text-truncate">
                     {bios &&
                       bios.map((item) => {
                      let bb = item.City + " - " + item.Name + " " + item.No;
                      return (
                       <option key={item.id} value={bb} 
                         className="text-truncate"  style={{  maxWidth:'280px',  marginLeft: '10px',   fontSize: "16px",  width:'250px' }}>
                     {item.Name} - {item.City}
                  </option>
                );
              })}
             

              </select>
                   <span className="select-line" style={{ backgroundColor: "#8d8d8d" ,position:'absolute',right:'30px',top:'37px',height:'40px',width:'0.5px'}}></span>
                 {/* <input style={{width:'100%',padding:'6px 13px 8px',border:'1px solid #8d8d8d',borderRadius:'4px',marginTop:'10px'}} type="text" /> */}
             </div>
            <div>
                <p className='openedMailTitel'>Status for udsendelse</p>
               <div style={{display:'flex', width:'387px'}}>
                 <div style={{borderTop:'1px solid #8d8d8d',padding:'6.5px 12px',width:'180px',borderLeft:'1px solid #8d8d8d',borderBottom:'1px solid #8d8d8d',borderTopLeftRadius:'4px',borderBottomLeftRadius:'4px',marginTop:'10px',height:'40px',position:'relative'}}>
                   <input  type="radio" name='newsletter' height='16px' width='16px'/>
                  <label htmlFor="" style={{position:'absolute',bottom:'7px'}}>Aktiveret</label>
                  
                  </div>
                  <div style={{border:'1px solid #8d8d8d',padding:'6.5px 11px',width:'209px',borderTopRightRadius:'4px',borderBottomRightRadius:'4px',marginTop:'10px',height:'40px',position:'relative'}}>
                   <input  type="radio"  name='newsletter' />
                    <label htmlFor="" style={{position:'absolute',bottom:'7px'}}>Ikke aktiveret</label>
                  
                  </div>
                </div>
                
             </div>
             </div>
              <div className='openedMailDiv' style={{paddingTop:'30px',paddingLeft:'80px'}}>
                 <div style={{width:'384px',marginRight:'51px'}}>
                   <p className='openedMailTitel'>Emnefelt på nyhedsmail</p>
                   <input style={{width:'100%',padding:'6px 13px 8px',border:'1px solid #8d8d8d',borderRadius:'4px',marginTop:'10px',color:'#101010'}} type="text" />
                </div>
                <div style={{marginTop:'28px'}}>
                  <img src={checkmarkRed} alt="" />
                  <span className='openedMailTitel'>Udsendelse ikke aktiveret</span>
                </div>
             </div>
             <button style={{width:'819px',backgroundColor:'#982f2f',height:'40px',margin:'33px 80px',color:'white',borderRadius:'4px',fontSize:'14px'}}>GEM</button>
             
             <svg xmlns="http://www.w3.org/2000/svg" width="979" height="1" viewBox="0 0 979 1" fill="none">
               <path d="M0 0.5H978.5" stroke="#CCCED1"/>
            </svg>
           <section style={{width:'540px',margin:'auto'}}>
              <div style={{display:'flex',justifyContent:'space-between'}}>
                <p className='openedMailTitel' style={{paddingTop:'8px'}}>Jeres mail</p>
                <button className='edit_content_btn'>REDIGER INDHOLD</button>
              </div>
              <div style={{border:'1px solid #8d8d8d',borderRadius:'4px',padding:'10px',marginTop:'18px'}}>ghhgh</div>
              <br />
          </section>
          </div> : null
          
        }
        </div>
    </div>
  )
}

export default NotSentNewsletter